var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-notFound"},[_c('img',{attrs:{"src":_vm.pic}}),_c('a',{on:{"click":_vm.goHome}},[_vm._v("回到首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }